import { CustomDoc } from "./../../../vo/custom-doc";
import { Injectable } from "@angular/core";
import { LanguageOption } from "../../../vo/language-option";
import { DocBar } from "app/core/vo/docBar";
import { ApplicationModel } from "app/core/models/application.model";
import { TrackingManager } from "app/core/tracking/tracking-manager";

@Injectable()
export class AppHeaderModelServiceAdaptive {
	private strCourseTitle = "";
	private arrLanguages: LanguageOption[] = [];
	private strCurrentLanguage: string = ``;
	private _customDocs: CustomDoc[] = [];
	private _docBar: DocBar;

	constructor() {}
	public set courseTitle(value: string) {
		this.strCourseTitle = value;
	}

	public get courseTitle(): string {
		return this.strCourseTitle;
	}

	public set languages(value: LanguageOption[]) {
		this.arrLanguages = value;
	}

	public get languages(): LanguageOption[] {
		return this.arrLanguages;
	}

	public get fullImagePath(): string {
		return "assets/ng_logo.svg";
	}
	public set language(value: string) {
		this.strCurrentLanguage = value;
	}

	public get language(): string {
		return this.strCurrentLanguage;
	}
	public set customDocs(value: CustomDoc[]) {
		/*let obj = [];
        for(let i=0;i<value.length;i++){
            if(value[i].isMandatory){
                obj.push(value[i]);
            }
        }*/
		let obj = [];
		for (let i = 0; i < value.length; i++) {
			if (
				value[i].geoLocation &&
				TrackingManager.instance.trackingVO.geoLocation
			) {
				if (
					value[i].geoLocation.toLowerCase() ==
					TrackingManager.instance.trackingVO.geoLocation.toLowerCase()
				)
					obj.push(value[i]);
			} else {
				obj.push(value[i]);
			}
		}
		this._customDocs = obj;
	}

	public get customDocs(): CustomDoc[] {
		return this._customDocs;
	}

	public set docBar(value: DocBar) {
		this._docBar = value;
	}
	public get docBar() {
		return this._docBar;
	}
	public get flowDirection() {
		return ApplicationModel.instance.flowDirection;
	}
}
